/* eslint-disable max-statements */
jQuery(document).ready(function($) {
  'use strict';
  var zero = 0;

  // eslint-disable-next-line no-warning-comments
  if ($('.mijninterpolis').length > zero) {
    window.public.addFonts('font_ipa.css');
    window.public.addFonts('font_iza.css');
  } else {
    if ($('[class*="ipa-"]').length > zero) {
      window.public.addFonts('font_ipa.css');
    }
    if ($('[class*="iza-"]').length > zero) {
      window.public.addFonts('font_iza.css');
    }
  }
});
